export   const menus = [
    {
      name: "Users",
      items: [
        { name: "Users List ", path: "/users" },
      ],
    },
    {
      name : "Service Locations",
      items: [
        { name: "Locations List", path: "/cities" },
      ],
    },
    {
      name: "Lab Technicians",
      items: [
        { name: "Technicians List", path: "/lab-technicians" },
      ],
    },
    {
      name: "Prescriptions",
      items: [
        { name: "Prescriptions List", path: "/prescriptions" },
      ],
    },
    {
      name: "Categories",
      items: [
        { name: "Categories List", path: "/categories" },
      ],
    },
    {
      name: "Sliders",
      items: [
        { name: "Sliders List", path: "/sliders" },
      ],
    },
    {
      name: "Banners",
      items: [
        { name: "Banners List", path: "/banners" },
      ],  
    },
    {
      name:"Slots",
      items: [
        { name: "Weekly Slots", path: "/slots/weekly" },
        { name: "Holidays", path: "/slots/holidays" },
      ],
    },
    {
      name: "Tests",
      items: [
        { name: "List Tests", path: "/tests" },
      ],
    },
    {
      name: "Packages",
      items: [
        { name: "List Packages", path: "/packages" },
      ],
    },
    {
      name: "Coupons",
      items: [
        { name: "Coupons List", path: "/coupons" },
      ],
    },
    {
      name: "Grouping",
      items: [
        { name: "Groups List", path: "/groupings" },
      ],
    },
    {
      name: "Orders",
      items: [
        { name: "List Orders", path: "/orders" },
      ],
    },
    {
      name: "Payment Gateway",
      items: [
        { name: "Razorpay Settings", path: "/payment-settings" },
      ],
    },
    {
      name: "Notifications",
      items: [
        { name: "Notifications List", path: "/notifications" },
      ],
    },
    {
      name: "Access",
      items: [
        { name: "Roles", path: "/roles" },
        { name: "Sub Admins", path: "/sub-admins" },
      ],
    }
  ];
